var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAppointment } from "../../../store/appointment/actions";
import { getUserById, getUserByIdClearData } from "../../../store/auth/actions";
export var useAppointment = function (quoteId, showAppointmentTab) {
    var _a = useState([]), appointmentRows = _a[0], setAppointmentRows = _a[1];
    var _b = useState(""), appointmentId = _b[0], setAppointmentId = _b[1];
    var _c = useState(""), executiveUserId = _c[0], setExecutiveUserId = _c[1];
    var dispatch = useDispatch();
    var responseGetAppointment = useSelector(function (state) {
        var _a;
        return ({
            responseGetAppointment: (_a = state.Appointment.responseGetAppointment) === null || _a === void 0 ? void 0 : _a.data
        });
    }).responseGetAppointment;
    // El endpoint /Users?users={id} devuelve una lista paginada,
    // tomamos el primer (y único) elemento.
    var responseGetUserById = useSelector(function (state) {
        var _a, _b;
        return ({
            responseGetUserById: (_b = (_a = state.Login.responseGetUserById) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[0]
        });
    }).responseGetUserById;
    useEffect(function () {
        if (showAppointmentTab && quoteId) {
            dispatch(getAppointment({
                quoteId: quoteId
            }));
        }
    }, [showAppointmentTab, quoteId]);
    useEffect(function () {
        var _a;
        if (responseGetAppointment) {
            var formattedDate = new Date(responseGetAppointment.appointmentDate).toLocaleString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
                timeZone: "UTC"
            }).replace(",", "").replace(/\//g, "-");
            var appointment = {
                id: responseGetAppointment.id,
                appointmentDate: formattedDate,
                status: responseGetAppointment.status,
                comment: responseGetAppointment.comment,
                officer: ""
            };
            setAppointmentId(appointment.id);
            setExecutiveUserId((_a = responseGetAppointment.executiveUserId) !== null && _a !== void 0 ? _a : "");
            setAppointmentRows([appointment]);
        }
    }, [responseGetAppointment]);
    // Cuando llega el appointment, traemos al asesor (executiveUserId)
    useEffect(function () {
        if (executiveUserId) {
            dispatch(getUserByIdClearData());
            dispatch(getUserById(executiveUserId));
        }
    }, [executiveUserId]);
    // Cuando responde el endpoint de usuario, completamos la columna officer
    useEffect(function () {
        var _a, _b;
        if (responseGetUserById && executiveUserId) {
            var name = (_a = responseGetUserById.name) !== null && _a !== void 0 ? _a : "";
            var lastName = (_b = responseGetUserById.lastName) !== null && _b !== void 0 ? _b : "";
            var officer_1 = "".concat(name, " ").concat(lastName).trim();
            setAppointmentRows(function (prev) {
                return prev.map(function (row) { return (__assign(__assign({}, row), { officer: officer_1 })); });
            });
        }
    }, [responseGetUserById, executiveUserId]);
    return useMemo(function () { return ({
        appointmentRows: appointmentRows,
        appointmentId: appointmentId,
    }); }, [quoteId, appointmentRows, appointmentId]);
};
